import React from 'react';
import PropTypes from 'prop-types';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
import { Text } from '@dtsl/react/dist/components/Text';
const Title = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    fontFamily: "bold",
    tag: "div",
    color: "var(--sib-color_content-secondary)",
    className: treeStyles['sib-tree-view__exp-title']
  }, title);
};
Title.propTypes = {
  title: PropTypes.string
};
export default Title;